import { IndexSort } from "@omni/types/api/search/algolia/shared/enum/indexSort.enum";

import { Config } from "@/utils/config.utils";

import { SortConfiguration } from "./sort.types";

export const productSortByConfiguration: Array<SortConfiguration> = [
    {
        tkLabel: "search.filters.sort.default",
        value: IndexSort.Default,
        default: true
    },
    {
        tkLabel: "search.filters.sort.price-asc",
        value: IndexSort.PriceAsc
    },
    {
        tkLabel: "search.filters.sort.price-desc",
        value: IndexSort.PriceDesc
    },
    {
        tkLabel: "search.filters.sort.rating-desc",
        value: IndexSort.OverallRatingDesc,
        isDisabled: () => !Config["feature-toggles"].reviews
    }
];
